import React, { useState } from 'react';
import { WorkLog, PositiveResponse, TicketPhotos, PhotoDisplay, MeetUp } from '../';
import './styles.scss';

const TicketWorkLogs = ({ ticketDetails }) => {
  const { worklogs, printable_text } = ticketDetails;
  const fieldMeetSet = new Set();
  const standbySet = new Set();

  const validWorklog = worklogs
    .filter(log => {
      if (ticketDetails.doc_type === 'ticket') {
        if (log.worklog_type === 'ticket_worklog') {
          return log;
        }
        if (log.worklog_type === 'fieldmeet_worklog') {
          if (fieldMeetSet.has(log.field_meet_id)) {
            return;
          } else {
            fieldMeetSet.add(log.field_meet_id);
            return log;
          }
        }
        if (log.worklog_type === 'standby_worklog') {
          if (standbySet.has(log.standby_id)) {
            return;
          } else {
            standbySet.add(log.standby_id);
            return log;
          }
        }
      } else if (ticketDetails.doc_type === 'fieldMeet') {
        if (log.worklog_type === 'fieldmeet_worklog') {
          return log;
        }
        if (log.worklog_type === 'standby_worklog') {
          if (standbySet.has(log.standby_id)) {
            return;
          } else {
            standbySet.add(log.standby_id);
            return log;
          }
        }
      } else if (ticketDetails.doc_type === 'standby' && log.worklog_type === 'standby_worklog') {
        return log;
      }
    })
    .sort((a, b) => a.start_time.localeCompare(b.start_time));

  const logCheck = log => {
    return (
      (ticketDetails.doc_type === 'ticket' && log.worklog_type === 'ticket_worklog') ||
      (ticketDetails.doc_type === 'fieldMeet' && log.worklog_type === 'fieldmeet_worklog') ||
      (ticketDetails.doc_type === 'standby' && log.worklog_type === 'standby_worklog')
    );
  };
  return (
    <div className="ticket-worklogs">
      <div className="ticket-worklogs-header">
        <details id="ticket-worklogs-details">
          <summary className="ticket-worklogs-title">Work Logs</summary>
          {validWorklog &&
            (validWorklog.length > 0
              ? validWorklog.map((worklog, index) => {
                  return (
                    <div key={index} className="ticket-worklogs-content">
                      {logCheck(worklog) && <WorkLog worklog={worklog} />}
                      {worklog?.positiveResponse?.id && (
                        <PositiveResponse positiveResponse={worklog.positiveResponse} />
                      )}
                    </div>
                  );
                })
              : 'No Worklogs')}
        </details>
      </div>
    </div>
  );
};

export default TicketWorkLogs;
